export const standardMappingSchema = {
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "Standard Bundle Title",
    },
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },

    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    seperator: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Seperator",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },
    plusIcon: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Card Border",
    },
    productQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Product Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Product Compare-At Price",
    },
    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    variantInfo: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Info",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;

export const volumeMappingSchema = {
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "Volume Bundle Title",
    },
    countdownTimer: {
        tabId: "General-1",
        sectionId: "countdown-timer-design",
        label: "Countdown Timer",
    },
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    discountLabel: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discount Label",
    },
    discountTag: {
        tabId: "General-1",
        sectionId: "special-text-design",
        label: "Discount tag",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Offer Title",
    },
    productQuantitySelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-quantity-selector",
        label: "Quantity Selector",
    },
    productQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Offer Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Offer Compare-At Price",
    },

    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    freeGiftCompareAtPrice: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-compare-at-price",
        label: "Free Gift Compare-At Price",
    },
    upsellProduct: {
        tabId: "Upsell Products-1",
        sectionId: "upsell-product",
        label: "Upsell Product",
    },
    upsellPrice: {
        tabId: "Upsell Products-1",
        sectionId: "upsell-price",
        label: "Upsell Price",
    },
    upsellCompareAtPrice: {
        tabId: "Upsell Products-1",
        sectionId: "upsell-compare-at-price",
        label: "Upsell Compare-At Price",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
    savingsSummary: {
        tabId: "General-1",
        sectionId: "savings-summary",
        label: "Savings Summary",
    },
    elegantBadge: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Tier Badge",
    },
} as const;

export const bxgyMappingSchema = {
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "BXGY Bundle Title",
    },
    countdownTimer: {
        tabId: "General-1",
        sectionId: "countdown-timer-design",
        label: "Countdown Timer",
    },
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    discountLabel: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discount Label",
    },

    discountTag: {
        tabId: "General-1",
        sectionId: "special-text-design",
        label: "Special tag",
    },
    plusSign: {
        tabId: "General-1",
        sectionId: "special-text-design",
        label: "Special Text Bacground",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Offer Title",
    },
    productQuantitySelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Quantity Selector",
    },
    productQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Offer Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Offer Compare-At Price",
    },

    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;
export const mixMatchMappingSchema = {
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "MixMatch Bundle Title",
    },
    quantityTab: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discount Tab",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    discountValue: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Subtext",
    },
    quantityLabel: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Text",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },

    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Offer Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Offer Compare-At Price",
    },
    productAddButton: {
        tabId: "Product Card-1",
        sectionId: "product-card-add-button",
        label: "Add Button",
    },
    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    addButton: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add Button",
    },
    productQuantitySelector: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Quantity Selector",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;
export const mixMatchSectionalMappingSchema = {
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "MixMatch Bundle Title",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    quantityTab: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discount Tab",
    },

    quantityLabel: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Text",
    },
    discountValue: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Subtext",
    },
    sectionTitle: {
        tabId: "General-1",
        sectionId: "section-tabs-design",
        label: "Description text",
    },
    sectionTab: {
        tabId: "General-1",
        sectionId: "section-tabs-design",
        label: "Section Tab",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },

    productQuantityText: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Offer Price",
    },

    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Offer Compare-At Price",
    },
    productAddButton: {
        tabId: "Product Card-1",
        sectionId: "product-card-add-button",
        label: "Add Button",
    },

    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    customFieldValue: {
        tabId: "Footer-1",
        sectionId: "custom_fields-design",
        label: "Custom Field Value",
    },
    customFieldTitle: {
        tabId: "Footer-1",
        sectionId: "custom_fields-design",
        label: "Custom Field Title",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    addButton: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add Button",
    },
    productQuantitySelector: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Quantity Selector",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;

export const fbtMappingSchema = {
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "FBT Bundle Title",
    },
    countdownTimer: {
        tabId: "General-1",
        sectionId: "countdown-timer-design",
        label: "Countdown Timer",
    },
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    discountLabel: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discount Label",
    },
    discountTag: {
        tabId: "General-1",
        sectionId: "special-text-design",
        label: "discount tag",
    },
    plusIcon: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Plus Icon",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },
    productQuantitySelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Quantity Selector",
    },
    productQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Product Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: " Compare-At Price",
    },
    productCheckbox: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Checkbox",
    },

    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;

export const productAddonsMappingSchema = {
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "Addon Bundle Title",
    },
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },

    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },
    productQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Product Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Product Compare-At Price",
    },
    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    productCheckbox: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart Background",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;

export const productAddonsPopupMappingSchema = {
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "addon Bundle Title",
    },
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    popupHeading: {
        tabId: "General-1",
        sectionId: "popup-design",
        label: "Popup Heading",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },
    productQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Quantity",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Product Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Product Compare-At Price",
    },
    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    productCheckbox: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart Background",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    skipOfferCta: {
        tabId: "Footer-1",
        sectionId: "footer-skip-offer-text",
        label: "Skip Offer CTA",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;

export const slideCartMappingSchema = {} as const;
export const thankYouPageMappingSchema = {} as const;

export const buyNMappingSchema = {
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "Bundle Title",
    },

    discountOption: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discounts Label",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    discountValue: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Discount Value",
    },
    quantityLabel: {
        tabId: "General-1",
        sectionId: "discount-label-design",
        label: "Text",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },

    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Offer Price",
    },
    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Offer Compare-At Price",
    },

    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },
    footerSection: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Section",
    },
    footerTotalBar: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Bar",
    },
    footerTotalText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },
    addButton: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add Button",
    },
    productQuantitySelector: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Quantity Selector",
    },
    freeGiftText: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-header",
        label: "Free Gift Header",
    },
    freeGiftProduct: {
        tabId: "Free Gift Card-1",
        sectionId: "free-gift-product",
        label: "Free Gift",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;

export const bundleBuilderMappingSchema = {
    bundlePreviewWrapper: {
        tabId: "Steps Page-1",
        sectionId: "step-general-design",
        label: "Bundle Widget",
    },

    stepLabel: {
        tabId: "Steps Page-1",
        sectionId: "step-label-design",
        label: "Step Label",
    },
    reviewStepPageTitle: {
        tabId: "Steps Page-1",
        sectionId: "step-page-title",
        label: "Step Page Title",
    },
    quantitySelector: {
        tabId: "General-1",
        sectionId: "product-card-add-to-cart",
        label: "Quantity Selector",
    },
    substepDropdown: {
        tabId: "Steps Page-1",
        sectionId: "step-cta-design",
        label: "Substep CTA",
    },
    buyNowCta: {
        tabId: "Product Card-1",
        sectionId: "product-card-add-to-cart",
        label: "Buy Now CTA",
    },
    freePriceTag: {
        tabId: "General-1",
        sectionId: "product-card-price",
        label: "Free Price Tag",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Product Price",
    },
    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },

    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Product Compare-At Price",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    totalBottomCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Total Compare-At Price",
    },

    imagePopup: {
        tabId: "Product Card-1",
        sectionId: "image-popup-design",
        label: "Product Image Popup",
    },
    bottomSectionBar: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Bottom Section Bar",
    },
    stepTitle: {
        tabId: "Steps Page-1",
        sectionId: "step-page-title",
        label: "Page Title",
    },
    stepSubTitle: {
        tabId: "Steps Page-1",
        sectionId: "step-page-subtitle",
        label: "Page Subtitle",
    },
    totalBottomBar: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Total Bar",
    },
    totalBottomBarPrice: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Total Price",
    },
    totalBottomBarStrikeOffPrice: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Strike Off Price",
    },
    totalBottomBarDiscount: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Discount",
    },
    nextCta: {
        tabId: "Steps Page-1",
        sectionId: "step-next-button",
        label: "Next CTA",
    },
    previousCta: {
        tabId: "Steps Page-1",
        sectionId: "step-previous-button",
        label: "Previous CTA",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },

    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },
    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },

    bundleReadyText: {
        tabId: "Review Page-1",
        sectionId: "review-bundle-title",
        label: "Bundle Title",
    },
    orderSummaryCard: {
        tabId: "Review Page-1",
        sectionId: "review-order-summary",
        label: "Order Summary Card",
    },
    orderSummaryTitle: {
        tabId: "Review Page-1",
        sectionId: "review-order-summary-header",
        label: "Order Summary Title",
    },
    orderSummaryTotal: {
        tabId: "Review Page-1",
        sectionId: "review-order-summary-header",
        label: "Order Summary Total",
    },
    orderSummaryRow: {
        tabId: "Review Page-1",
        sectionId: "review-order-summary-rows",
        label: "Order Summary Row",
    },
    reviewBottomCta: {
        tabId: "Product Card-1",
        sectionId: "product-card-add-to-cart",
        label: "Bottom CTA",
    },
    reviewEditBundleCta: {
        tabId: "Review Page-1",
        sectionId: "review-edit-bundle-cta",
        label: "Edit Bundle CTA",
    },
    reviewProductCard: {
        tabId: "Review Page-1",
        sectionId: "review-product-card",
        label: "Product Card",
    },
    reviewProductCardAddonProducts: {
        tabId: "Review Page-1",
        sectionId: "add-on-products",
        label: "Addon Product Card",
    },
    subscribeAndSaveMore: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Subscribe Button",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;
export const bbPlaceholderMappingSchema = {
    bundlePreviewWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Bundle Widget",
    },
    placeholderItemWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Add Product Container",
    },
    productWrapper: {
        tabId: "General-1",
        sectionId: "general-design",
        label: "Product Widget",
    },
    bundleTitle: {
        tabId: "General-1",
        sectionId: "bundle-title-design",
        label: "Bundle Title",
    },

    stepLabel: {
        tabId: "Steps Page-1",
        sectionId: "step-label-design",
        label: "Step Label",
    },
    reviewStepPageTitle: {
        tabId: "Steps Page-1",
        sectionId: "step-page-title",
        label: "Step Page Title",
    },
    quantitySelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-add-to-cart",
        label: "Quantity Selector",
    },
    substepDropdown: {
        tabId: "Steps Page-1",
        sectionId: "step-cta-design",
        label: "Substep CTA",
    },
    buyNowCta: {
        tabId: "Product Card-1",
        sectionId: "product-card-add-to-cart",
        label: "Buy Now CTA",
    },
    addedQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-added-quantity",
        label: "Quantity Label",
    },
    freePriceTag: {
        tabId: "General-1",
        sectionId: "product-card-price",
        label: "Free Price Tag",
    },
    productPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-price",
        label: "Product Price",
    },
    variantSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-variant-selector",
        label: "Variant Selector",
    },

    productCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Product Compare-At Price",
    },
    productCard: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Card",
    },
    productTitle: {
        tabId: "Product Card-1",
        sectionId: "product-card-name",
        label: "Product Title",
    },

    productImage: {
        tabId: "Product Card-1",
        sectionId: "product-card-general",
        label: "Product Image",
    },
    totalBottomCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Total Compare-At Price",
    },

    imagePopup: {
        tabId: "Product Card-1",
        sectionId: "image-popup-design",
        label: "Product Image Popup",
    },
    bottomSectionBar: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Bottom Section Bar",
    },
    stepTitle: {
        tabId: "Steps Page-1",
        sectionId: "step-page-title",
        label: "Page Title",
    },
    stepSubTitle: {
        tabId: "Steps Page-1",
        sectionId: "step-page-subtitle",
        label: "Page Subtitle",
    },
    totalBottomBar: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Total Bar",
    },
    totalBottomBarPrice: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Total Price",
    },
    nextCta: {
        tabId: "Steps Page-1",
        sectionId: "step-next-button",
        label: "Next CTA",
    },
    previousCta: {
        tabId: "Steps Page-1",
        sectionId: "step-previous-button",
        label: "Previous CTA",
    },
    addToCartCta: {
        tabId: "Footer-1",
        sectionId: "footer-add-to-cart",
        label: "Add to Cart CTA",
    },

    bundleReadyText: {
        tabId: "Review Page-1",
        sectionId: "review-bundle-title",
        label: "Bundle Title",
    },
    footerContainer: {
        tabId: "Footer-1",
        sectionId: "order_summary-design",
        label: "Order Summary Card",
    },
    orderSummaryLabel: {
        tabId: "Footer-1",
        sectionId: "order-summary-header-design",
        label: "Order Summary Label",
    },
    orderSummaryValue: {
        tabId: "Footer-1",
        sectionId: "order-summary-header-design",
        label: "Order Summary Value",
    },
    specialText: {
        tabId: "Footer-1",
        sectionId: "special-text-design",
        label: "Special Text",
    },
    totalFooterText: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total",
    },
    footerTotalPrice: {
        tabId: "Footer-1",
        sectionId: "footer-total",
        label: "Footer Total Price",
    },
    footerCompareAtPrice: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Footer Compare-At Price",
    },
    footerTotalQuantity: {
        tabId: "Product Card-1",
        sectionId: "product-card-compare-at-price",
        label: "Product Quantity",
    },
    bottomBar: {
        tabId: "Steps Page-1",
        sectionId: "step-bottom-bar",
        label: "Bottom Bar",
    },
    subscribeAndSaveMore: {
        tabId: "Steps Page-1",
        sectionId: "step-previous-button",
        label: "Previous CTA",
    },
    swatchesSelector: {
        tabId: "Product Card-1",
        sectionId: "product-card-swatches-selector",
        label: "Swatches Selector",
    },
} as const;
